import React from 'react';

import Box from './Box.js';
import './Confirm.scss';

export default (confirmClick, message) => (props) => {
		return <Box title={props.title} className='confirm-ui'>
			{message}
			<p> </p>
			<div className="button-holder">
				<button className="block" onClick={props.onClose}>No</button>
				<button className="block red" onClick={() => {
					confirmClick();
					props.onClose();
				}}>Yes, I'm sure.</button>
			</div>
		</Box>
};